import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useUserStore } from '@/store/useUserStore'
import {storeToRefs} from "pinia"


const routes: Array<RouteRecordRaw> = [
      {path:'/',
      component: () =>  import(/* webpackChunkName: "index" */'@/views/index.vue'), 
      meta: {
          title: '首页'
      }
    },
    {path:'/service',
      component: () => import(/* webpackChunkName: "service" */'@/views/service.vue'), 
      meta: {
          title: '服务'
      }
    },
    {path:'/about',
    component: () => import(/* webpackChunkName: "about" */'@/views/about.vue'),  
      meta: {
          title: '关于'
      }
    },
    {path:'/case',
      component: () => import(/* webpackChunkName: "case" */'@/views/case.vue'),   
      meta: {
          title: '案例'
      }
    },
    {path:'/caseDetail/:id?',
      component: () => import(/* webpackChunkName: "caseDetail" */'@/views/caseDetail.vue'),   
      meta: {
          title: '案例详情'
      }
    },
    {path:'/news',
      component: () => import(/* webpackChunkName: "news" */'@/views/news.vue'),   
      meta: {
          title: '动态'
      }  
    },
    {path:'/newsDetail/:id?',
      component: () => import(/* webpackChunkName: "newsDetail" */'@/views/newsDetail.vue'),   
      meta: {
          title: '动态'
      }
    },
  {
    path: '/admin',
    name: '登录',
    component: () => import(/* webpackChunkName: "login" */ '../views/admin/HomeView.vue')
  },{
    path: '/manage',
    name: '后台',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/mainView.vue'),
    children:[
      {
        path: '/manage/addCase/:id?',
        name: '发布案例',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "addCase" */ '../views/admin/addCase.vue')    
      },{
        path: '/manage/caselist',
        name: '案例列表',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "caseList" */ '../views/admin/caseList.vue')    
      },
      {
        path: '/manage/newslist',
        name: '动态列表',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "newslist" */ '../views/admin/newslist.vue')    
      },
      {
        path: '/manage/addNews/:id?',
        name: '发布动态',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "publishNews" */ '../views/admin/publishNews.vue')    
      },
      {
        path: '/manage/addSortName/:id?',
        name: '创建案例分类',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "publishNews" */ '../views/admin/addSortName.vue')    
      },
      {
        path: '/manage/caseSortList',
        name: '分类列表',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "caseSortList" */ '../views/admin/caseSortList.vue')    
      }
    ]
    
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to,from,next)=>{
  let store = useUserStore()
  const {authToken} = storeToRefs(store)
  let localAuthToken = localStorage.getItem('authToken')

   if((authToken.value != "" || (localAuthToken != "" && localAuthToken != null))){
      if(to.path == "/admin"){  
        next("/manage/caselist")
      }else{
        next()
      }  
   }else if(authToken.value == "" && (localAuthToken == "" || localAuthToken == null)){

     if(to.path.indexOf('/manage') != -1 ){
         next("/admin")
      }else{
        next()
      } 
   }
})
export default router
